import React, { useState } from 'react';
import BoxContainer from '../BoxContainer/BoxContainer';
import { useForm, Controller } from 'react-hook-form';
import { connect } from 'react-redux';
import { useCreateClient } from '../../utils/service/service_user_api';
import { setItem, removeItem, getISODateString } from '../../utils/util';
import { withRouter, Link } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../CreateAccountWizard/updateAction';
import get from 'lodash/get';
import ErrorMessageInput from '../ErrorMessajeInput/ErrorMessageInput';
import { updateAuth0User } from '../../reducers/account/AccountActions';
import PhoneField from '../PhoneField/PhoneField';
import linkIcon from '../../styles/assets/external-link-icon.svg';
import * as APIUtil from '../../utils/service/service_api';
import css from '../../styles/modules/BoxContainer/createaccountfirststep.module.css';
import '../CreateAccountWizard/createAccount.css';
import { isEmpty } from 'lodash';
import { BeatLoader } from 'react-spinners';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const Title = () => <div className="create-account__line-container"></div>;

const InfoCreateAccount = ({ introductoryText }) => {
  const organization = 'Paymints';
  return (
    <div className={css.introductoryText}>
      {introductoryText
        ? introductoryText
        : `To create an account and transfer money to ${organization}, please confirm the following details. All fields are required.`}
    </div>
  );
};

const FieldsPersonalInformation = ({
  client,
  register,
  errors,
  setValue,
  watch,
  control,
  branding,
  setDisabled,
}) => {
  const accentColor = branding?.accentColor || '#000000';
  const [border1, setBorder1] = useState(`1px solid ${accentColor}`);
  const [border2, setBorder2] = useState(`1px solid ${accentColor}`);
  const [border3, setBorder3] = useState(`1px solid ${accentColor}`);
  const [border4, setBorder4] = useState(`1px solid ${accentColor}`);
  const [isFocused, setIsFocused] = useState(false);
  const focusedBorder = `2px solid ${accentColor}`;
  const blurredBorder = `1px solid ${accentColor}`;
  const borderStyle = isFocused ? focusedBorder : blurredBorder;
  const [border5, setBorder5] = useState(`1px solid ${accentColor}`);

  const phoneNumber = watch('phone_number', '');

  const formatAsPhoneNumber = (input) => {
    const numericInput = input.replace(/\D/g, '');
    let formattedNumber = '';
    if (numericInput.length > 3) {
      const areaCode = numericInput.substring(0, 3);
      const prefix = numericInput.substring(3, 6);
      const lineNumber = numericInput.substring(6);
      formattedNumber = `(${areaCode}) ${prefix}-${lineNumber}`;
    } else {
      formattedNumber = numericInput;
    }
    return formattedNumber;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      const currentNumber = watch('phone_number');
      const numericInput = currentNumber.replace(/\D/g, '');
      if (numericInput.length > 0) {
        // Remove the last character from numericInput
        const updatedNumber = numericInput.slice(0, -1);

        // Format and set the updated number
        setValue('phone_number', formatAsPhoneNumber(updatedNumber));

        // Prevent the default behavior of the Backspace key
        e.preventDefault();
      }
    }
  };

  const handleInput = () => {
    if (formatAsPhoneNumber(phoneNumber).length <= 14) {
      setValue('phone_number', formatAsPhoneNumber(phoneNumber));
    }
  };

  const handleFocus = () => {
    setBorder5(`2px solid ${accentColor}`);
  };

  const handleBlur = () => {
    setBorder5(`1px solid ${accentColor}`);
  };

  return (
    <div className={css.formWrapper}>
      <div className={css.subWrapper}>
        <div
          style={{
            boxShadow: `0vw 3px 3px ${accentColor.replace(
              /[\d.]+\)$/g,
              '0.25)',
            )}`,
          }}
          className={css.textFieldSub2}
        >
          <div className={css.fullWidthFieldContainer}>
            <div className={css.inputContainerFullWidth}>
              <p className={css.tagLabelFullWidth}>First Name</p>
              <input
                type="text"
                placeholder=" "
                id="firstName"
                name="firstName"
                ref={register({ required: true, maxLength: 30 })}
                className={css.textFieldSmall}
                onFocus={() => setBorder1(`2px solid ${accentColor}`)}
                onBlur={() => setBorder1(`1px solid ${accentColor}`)}
                style={{ border: border1, outline: 'none' }}
              />
              {errors.firstName && errors.firstName.type === 'required' && (
                <ErrorMessageInput>This is required</ErrorMessageInput>
              )}
              {errors.firstName && errors.firstName.type === 'maxLength' && (
                <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
              )}
            </div>

            <div className={css.inputContainerFullWidth}>
              <p className={css.tagLabelFullWidth}>Middle Name [Optional]</p>
              <input
                type="text"
                id="middleName"
                name="middleName"
                className={css.textFieldSmall}
                placeholder=" "
                autoComplete="no"
                ref={register}
                onFocus={() => setBorder2(`2px solid ${accentColor}`)}
                onBlur={() => setBorder2(`1px solid ${accentColor}`)}
                style={{ border: border2, outline: 'none' }}
              />
            </div>

            <div className={css.inputContainerFullWidth}>
              <p className={css.tagLabelFullWidth}>Last Name</p>
              <input
                type="text"
                id="lastName"
                name="lastName"
                className={css.textFieldSmall}
                placeholder=" "
                autoComplete="no"
                onFocus={() => setBorder3(`2px solid ${accentColor}`)}
                onBlur={() => setBorder3(`1px solid ${accentColor}`)}
                style={{ border: border3, outline: 'none' }}
                ref={register({ required: true, maxLength: 50 })}
              />
              {errors.lastName && errors.lastName.type === 'required' && (
                <ErrorMessageInput>This is required</ErrorMessageInput>
              )}
              {errors.lastName && errors.lastName.type === 'maxLength' && (
                <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
              )}
              <p className={css.idText}>
                Must match your driver's license or government-issued ID.
              </p>
            </div>
            <div className={css.inputContainerFullWidth}>
              <p className={css.tagLabelFullWidth}>Email</p>
              <input
                type="email"
                id="email"
                name="email"
                className={css.textFieldSmall}
                placeholder=" "
                autoComplete="no"
                onFocus={() => setBorder4(`2px solid ${accentColor}`)}
                onBlur={() => setBorder4(`1px solid ${accentColor}`)}
                style={{ border: border4, outline: 'none' }}
                ref={register({ required: true, maxLength: 50 })}
              />

              {errors.lastName && errors.lastName.type === 'required' && (
                <ErrorMessageInput>This is required</ErrorMessageInput>
              )}
              {errors.lastName && errors.lastName.type === 'maxLength' && (
                <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
              )}
            </div>

            <div className={css.inputContainerFullWidth}>
              <p className={css.tagLabelFullWidth}>Phone</p>
              <input
                ref={
                  formatAsPhoneNumber(phoneNumber).length <= 14
                    ? register({ required: true, maxLength: 14 })
                    : null
                }
                className={css.textFieldSmall}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onInput={handleInput}
                onKeyDown={handleKeyDown}
                style={{ border: border5, outline: 'none' }}
                name="phone_number"
                type="tel"
                maxLength={14}
                inputMode="tel"
              />

              {errors.lastName && errors.lastName.type === 'required' && (
                <ErrorMessageInput>This is required</ErrorMessageInput>
              )}
              {errors.lastName && errors.lastName.type === 'maxLength' && (
                <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
              )}
            </div>
          </div>
        </div>
      </div>
      <FooterInformation setDisabled={setDisabled} />
    </div>
  );
};

const PersonalInformation = ({
  client,
  watch,
  register,
  errors,
  setValue,
  control,
  branding,
  setDisabled,
}) => (
  <div className="create-account__information-container">
    {/* <div className="create-account__title-information">
      Personal Information
    </div> */}
    <FieldsPersonalInformation
      client={client}
      register={register}
      errors={errors}
      setValue={setValue}
      control={control}
      watch={watch}
      branding={branding}
      setDisabled={setDisabled}
    />
  </div>
);

const FieldsContactInformation = ({ errors, control, branding }) => (
  <div className={css.formWrapper}>
    <div className={css.subWrapper}>
      <h5 className={css.wrapperLabel}>
        We will send a security code to your mobile phone for account
        verification.
      </h5>
      <div className={css.textFieldSub2}>
        <div className={css.fullWidthFieldContainer}>
          <div className={css.inputContainerFullWidth}>
            <p className={css.tagLabelFullWidth}>First Name</p>
            <Controller
              as={PhoneField}
              control={control}
              name="phone_number"
              placeholder=" "
              className={css.textFieldSmall}
              rules={{ required: true }}
            />
            <p className={css.idText}>
              Standard text messaging and provider rates may apply.
            </p>

            {errors.phone_number && errors.phone_number.type === 'required' && (
              <ErrorMessageInput>This is required</ErrorMessageInput>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ContactInformation = ({ client, errors, control, branding }) => {
  const email = get(client, 'email');
  return email ? null : (
    <div className="create-account__information-container">
      <div className="create-account__title-information">
        Contact Information
      </div>
      <FieldsContactInformation
        branding={branding}
        errors={errors}
        control={control}
      />
    </div>
  );
};

const FooterInformation = ({ setDisabled }) => (
  <div className={css.footerWrapper}>
    <span>
      <input
        type="checkbox"
        className="form-group"
        onChange={(e) => setDisabled(!e.target.checked)}
      />{' '}
    </span>{' '}
    {'By clicking Create Account, you agree to paymints.io '}
    <a
      href="https://www.paymints.io/terms-of-use/"
      target="_blank"
      rel="noopener noreferrer"
      className="paymints__link"
    >
      Terms of Service{' '}
      <img src={linkIcon} className="create-account__link-icon" alt="" />{' '}
    </a>
    {' and '}
    <a
      href="https://www.paymints.io/privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
      className="paymints__link nowrap"
    >
      Privacy Policy{' '}
      <img src={linkIcon} className="create-account__link-icon" alt="" />
    </a>
    {' as well as our partner'} Cross River Bank’s
    <a
      href="https://www.crossriver.com/terms-conditions"
      target="_blank"
      rel="noopener noreferrer"
      className="paymints__link"
    >
      {' '}
      Terms of Service{' '}
      <img src={linkIcon} className="create-account__link-icon" alt="" />
    </a>{' '}
    and{' '}
    <a
      href="https://www.crossriver.com/privacy-notice"
      target="_blank"
      rel="noopener noreferrer"
      className="paymints__link"
    >
      Privacy Policy.
      <img src={linkIcon} className="create-account__link-icon" alt="" />
    </a>
  </div>
);

const nextStep = (history) => {
  history.push(`/create-account/step-2${get(history, 'location.search')}`);
};

const FirstStep = (props) => {
  const history = useHistory();
  const { beforeContinue, onUpdateAuth0User, refetchNewClient } = props;
  const { register, handleSubmit, errors, watch, setValue, control } = useForm({
    defaultValues: props.client,
  });
  const { createClient } = useCreateClient();
  const { action } = useStateMachine(updateAction);
  const [error, onSetError] = useState({
    active: false,
    type: '',
    messageError: '',
  });

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const onSubmit = (newUser) => {
    newUser.phone_number = newUser?.phone_number?.replace(/\D+/g, '');
    try {
      setLoading(true);
      removeItem('login_user');
      onSetError({ active: false, type: '', messageError: '' });
      // const email = get(props.user, 'email')
      //   ? get(props.user, 'email')
      //   : `${newUser.phone_number}@paymints.io`;

      const { email, firstName, lastName, middleName, phone_number } = newUser;

      const tenantId = get(props, 'tenant._id');
      if (isEmpty(tenantId))
        onSetError({
          active: true,
          messageError: 'Tenant not found, please check url',
        });
      if (email && !isEmpty(tenantId)) {
        // Search for all clients with that email
        refetchNewClient({
          mobilePhone: '+1' + phone_number.replace(/\D+/g, ''),
        }).then((response) => {
          const client = get(response, 'data.client');
          delete newUser.phone_number;
          if (!client) {
            let clientData = {};
            // Create a new client
            createClient({
              variables: {
                client: {
                  ...newUser,
                  // email: email,
                  mobilePhone: '+1' + phone_number.replace(/\D+/g, ''),
                  tenant: {
                    link: tenantId,
                  },
                  createdAt_utc: getISODateString(),
                  createdAt_offset: "+00:00",
                  updatedAt_utc: getISODateString(),
                  updatedAt_offset: "+00:00",
                },
              },
            })
              .then((res) => {
                clientData = res.data.insertOneClient;
                beforeContinue();
              })
              .then(() => {
                // Create Auth0 client
                const userEmail = get(props.user, 'email');
                if (!userEmail) {
                  const auth0User = {
                    email: email,
                    phone_number: `+1${phone_number.replace(/\D+/g, '')}`,
                    name: `${newUser.firstName} ${newUser.lastName}`,
                    connection: 'sms',
                  };
                  const auth0Payload = {
                    create_user: auth0User,
                    role: 'paymints_admin',
                    new_user_role: 'paymints_client',
                  };

                  onUpdateAuth0User(tenantId, auth0Payload)
                    .then((response) => {
                      if (response === 'error') {
                        onSetError({
                          active: true,
                          messageError:
                            'Account exists for phone number.  Please login in.',
                        });
                        setLoading(false);
                      } else {
                        getCode(tenantId, clientData?._id, clientData);
                      }
                    })
                    .then(() => {
                      action(newUser);
                    });
                } else {
                  action(newUser);
                  nextStep(props.history);
                }
              });
          } else {
            onSetError({ active: true, type: 'sms' });
            setItem('login_user', 'existing_user');
          }
        });
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const getCode = (tenantId, clientid, client) => {
    APIUtil.getSMSCode(tenantId, clientid).then(
      (res) => {
        props.history.push('/create-account/account-verification', { client });
        setLoading(false);
      },
      (error) => {
        console.log(error);
      },
    );
  };

  return (
    <BoxContainer showLoginButton withDoubleBorder withLogButton brandLogo>
      {/* <Title /> */}
      <div
        className="create-account__paymints-link"
        style={{
          textAlign: 'right',
          marginTop: '-16px',
          paddingBottom: '12px',
        }}
        onClick={() => props.history.push('/login')}
      >
        Login
      </div>
      <InfoCreateAccount
        introductoryText={
          history?.location?.state?.state === 'NO_USER'
            ? 'Please create a new account'
            : props.introductoryText
        }
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <PersonalInformation
          client={props.client}
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          control={control}
          branding={props.branding}
          setDisabled={setDisabled}
        />
        <div className="d-flex justify-content-center align-items-center mt-5">
          <button
            disabled={loading || disabled}
            style={
              disabled
                ? { backgroundColor: '#e1e1e1', opacity: '0.5' }
                : { backgroundColor: props?.branding?.accentColor || '#000000' }
            }
            className={css.getStartedBtn}
          >
            {!loading ? (
              'Create Account'
            ) : (
              <BeatLoader size={8} color="white" />
            )}
          </button>
          <div className="ml-3">
            Already registered? Click to{' '}
            <span
              className="create-account__paymints-link"
              onClick={() => props.history.push('/login')}
            >
              Login
            </span>
          </div>
        </div>
        {error.active ? (
          <div className="create-account__footer-buttons center">
            {error.active && (
              <ErrorMessageInput>{error.messageError}</ErrorMessageInput>
            )}
            {error.active && error.type === 'sms' && (
              <ErrorMessageInput>
                Account exists for phone number. Please{' '}
                <Link to="/login">login</Link>
              </ErrorMessageInput>
            )}
          </div>
        ) : null}
      </form>
    </BoxContainer>
  );
};

export default withRouter(
  connect((state) => ({}), {
    onUpdateAuth0User: updateAuth0User,
  })(FirstStep),
);
